
import { useState } from 'react';

export interface SecurityFilters {
  severity: string;
  eventType: string;
  status: string;
  contentType: string;
  searchTerm: string;
}

export const useSecurityFilters = () => {
  const [filters, setFilters] = useState<SecurityFilters>({
    severity: 'all',
    eventType: 'all',
    status: 'all',
    contentType: 'all',
    searchTerm: '',
  });

  const updateFilter = (key: keyof SecurityFilters, value: string) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  return {
    filters,
    updateFilter,
    setFilters
  };
};
